import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionTimeoutService } from 'src/app/services/authentication/session-timeout-service';
import { JwtService } from 'src/app/services/jwt/jwt-service';
import { ModulesService } from 'src/app/services/modules/modules-service';
import { NotificationService } from 'src/app/services/notification/notification-service';
import { PermissionService } from 'src/app/services/user/permission-service';

export const authGuard: CanActivateFn = async (route, state) => {
  const moduleService = inject(ModulesService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);
  const permissionService = inject(PermissionService);
  const jwtService = inject(JwtService);
  const sessionTimeoutService = inject(SessionTimeoutService);

  const publicModuleCodes = ['login', 'register'];
  const isPublic = publicModuleCodes.includes(route.data['moduleCode']);
  const token = jwtService.getToken();

  if (!token && !isPublic) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
  // if (token && (route.data['moduleCode'] !== 'login' || route.data['moduleCode'] !== 'register')) {
  //   console.log('test');
  //   authService.setUserPermsCache();
  // }

  if (isPublic) {
    if (token) {
      router.navigate(['/dashboard']);
    }
    return true;
  }

  if (token && !isPublic) {
    sessionTimeoutService.init();
  }

  const routePath: string = (route.routeConfig?.path === '' ? route.parent?.routeConfig?.path : route.routeConfig?.path) ?? '';
  const allowed = await permissionService.canAccessRoute(routePath, route.data['moduleCode'], route.params['moduleKey'], route.data['permission']);
  if (token && allowed) {
    notificationService.startConnection();
    await moduleService.loadModules();
    return true;
  }

  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};
